import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", variant = "dark" }) {
  const nameColor = variant === "light" ? "text-white" : "text-[#0b2545]";
  const subColor = variant === "light" ? "text-slate-400" : "text-slate-400";
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 leading-none ${className}`}>
      <img
        src="/armstrong-emblem.png"
        alt="Armstrong Technologies"
        className="h-9 w-auto object-contain"
      />
      <div className="flex flex-col">
        <span className={`font-display font-extrabold tracking-tight text-[15px] leading-none ${nameColor}`}>
          ARMSTRONG
        </span>
        <span className={`text-[7px] tracking-[0.35em] font-semibold mt-[3px] ${subColor}`}>
          TECHNOLOGIES
        </span>
      </div>
    </Link>
  );
}
